import type { SessionPayload } from "@/types/api";
import { request } from "./transport";

export interface UpdateUserPayload {
  expected_user_id?: number;
  name?: string;
  email?: string | null;
  locale?: string | null;
  theme?: string | null;
  pin?: string;
  current_pin?: string;
  metadata?: Record<string, unknown>;
}

export const users = {
  updateMe: (
    patch: UpdateUserPayload,
    options: Pick<RequestInit, "keepalive"> = {},
  ) =>
    request<SessionPayload>("/users/me", {
      ...options,
      method: "PATCH",
      body: JSON.stringify({ user: patch }),
    }),
  updateAvatar: (avatar: File) => {
    const body = new FormData();
    body.append("user[avatar]", avatar);
    return request<SessionPayload>("/users/me", {
      method: "PATCH",
      body,
    });
  },
};
